export interface IPromptProfileMeta {
  options: IPromptOptions;

  // this should really be part of IPromptOptions below, but the keys for that interface are used everywhere
  baseHtmlStyleFile: {name: string | undefined; file: File | undefined} | undefined;
}

export interface IPromptOptions {
  role: string[];
  tone: string[];
  format: string[];
  resultLength: string[];
  explanationDifficulty: string[];
  outputLanguage: string[];
}

type IPromptOptionsKeys = keyof IPromptOptions; // TODO- Refactor to return keys based on IPromptOptions above
export function getIPromptOptionsKeys(): IPromptOptionsKeys[] {
  return [
    'role',
    'tone',
    'format',
    'resultLength',
    'explanationDifficulty',
    'outputLanguage',
  ];
}
